import './main.less';
import { actions, selectors } from '../../../../modules/dashboard';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';

// local
import AppPromo from './components/app-promo.js';
import BmPromo from './components/bm-promo.js';

// shared
import renderViewsState from '../../../../modules/shared/render-views-state';
import Animate from '../../../../modules/shared/animation';
import PaginationArrowControl from '../../../../modules/shared/pagination/arrows-control';
import PaginationBulletControl from '../../../../modules/shared/pagination/bullet-control';
import Offers from '../../../../modules/dashboard/components/offers';
import News from '../../../../modules/dashboard/components/news';
import Polls from '../../../../modules/dashboard/components/polls';
import NewPromoPopup from '../../../../modules/dashboard/components/popups/new-promo-popup';
import WasDeletedDomainPopup from '../../../../modules/dashboard/components/popups/was-deleted-domain-popup';

//
// const Banner = () => (
// 	<a href="http://sempro.com.ua/?utm_source=everad&utm_medium=dashboard&utm_campaign=710x428_general" target="_blank">
// 		<div className="banner"></div>
// 	</a>
// );

const Main = renderViewsState(props => {
	const { intl } = props;
	const isDeletedDomainPopupShowed = !isEmpty(props.popups.wasDeletedOfferDomain)
		&& Object.keys(props.popups.wasDeletedOfferDomain).length;
	const isNewPromoPopupShowed = !isEmpty(props.popups.newPromo)
		&& Object.keys(props.popups.newPromo).length;
	return (
		<div className="dashboard container container__with-columns">
			{
				props.user.general.status === 'banned' &&
				<div className="alert"><span>{intl('Ваш аккаунт заблокирован')}</span></div>
			}
			{
				props.user.general.status === 'not_confirmed' &&
				<div className="alert">
					<span>{intl('Пожалуйста, подтвердите свой Email, чтобы иметь возможность заказывать выплаты')}</span>
				</div>
			}

			<div className="column_left">
				<Polls {...props} />
				{!props.topOffers.data.length ? '' : <div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">{intl('ТОП офферы')}</h2>
						<PaginationArrowControl
							paginatedComponentName='topOffers'
							paginationActions={props.pagination()}
							nextPage={props.topOffers.nextPageNumber}
							prevPage={props.topOffers.prevPageNumber}
							isCanNotMoveToNext={props.topOffers.isCanNotMoveToNext}
							isCanNotMoveToPrev={props.topOffers.isCanNotMoveToPrev}/>
					</div>
					<Animate>
						<Offers key={props.topOffers.currentPage}
							data={props.topOffers.data}
							currenciesForOffers={props.currenciesForOffers}
							changeActiveCurrency={props.changeActiveCurrency}
							intl={intl}
						/>
					</Animate>
					<PaginationBulletControl
						paginatedComponentName='topOffers'
						paginationActions={props.pagination()}
						totalPage={props.topOffers.totalPages}
						currentPage={props.topOffers.currentPage}/>
				</div>}
				<div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">{intl('Новые офферы')}</h2>
						<PaginationArrowControl
							paginatedComponentName='offers'
							paginationActions={props.pagination()}
							nextPage={props.offers.nextPageNumber}
							prevPage={props.offers.prevPageNumber}
							isCanNotMoveToNext={props.offers.isCanNotMoveToNext}
							isCanNotMoveToPrev={props.offers.isCanNotMoveToPrev}/>
					</div>
					<Animate>
						<Offers key={props.offers.currentPage}
							data={props.offers.data}
							currenciesForOffers={props.currenciesForOffers}
							changeActiveCurrency={props.changeActiveCurrency}
							intl={intl}
						/>
					</Animate>
					<PaginationBulletControl
						paginatedComponentName='offers'
						paginationActions={props.pagination()}
						totalPage={props.offers.totalPages}
						currentPage={props.offers.currentPage}/>
				</div>

			</div>
			<div className="column_right main__right-column">
				<AppPromo intl={props.intl}/>
				<div className="news-block">
					<div className="container__content-title news__title">
						<h2 className="font-proxima-nova-bold">{intl('Новости')}</h2>
						<PaginationArrowControl
							paginatedComponentName='news'
							paginationActions={props.pagination()}
							nextPage={props.news.nextPageNumber}
							prevPage={props.news.prevPageNumber}
							isCanNotMoveToNext={props.news.isCanNotMoveToNext}
							isCanNotMoveToPrev={props.news.isCanNotMoveToPrev}
							onActionCallback={props.closeOpenedNews}/>
					</div>
					<News
						key={props.news.currentPage}
						data={props.news.data}
						openedNewsOffers={props.openedNewsOffers}
						newsTypesEnum={props.newsTypesEnum}
						openedNewsId={props.openedNewsId}
						toggleNews={props.toggleNews}
						intl={intl} />
				</div>
				<BmPromo intl={props.intl}/>
			</div>
			{isNewPromoPopupShowed
				? <NewPromoPopup
					intl={intl}
					landingLanguages={props.landingLanguages}
					data={props.popups.newPromo}
					onClose={props.closeOnStartPopup}
				/>
				: null}
			{isDeletedDomainPopupShowed && !isNewPromoPopupShowed
				? <WasDeletedDomainPopup
					intl={intl}
					data={props.popups.wasDeletedOfferDomain}
					onClose={props.closeOnStartPopup}
				/>
				: null}
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		user: selectors.getUserData(state),
		offers: selectors.getOffers(state),
		topOffers: selectors.getTopOffers(state),
		landingLanguages: selectors.getLandingLanguages(state),
		news: selectors.getNews(state),
		newsTypesEnum: selectors.getNewsTypesEnum(),
		openedNewsId: selectors.getOpenedNewsId(state),
		openedNewsOffers: selectors.getOpenedNewsOffers(state),
		manager: selectors.getManager(state),
		charts: selectors.getCharts(state),
		pollUrl: selectors.getPollUrl(state),
		popups: selectors.getPopups(state),
		currenciesForOffers: selectors.getCurrenciesForOffers(state),
		masterAccountDisplayStatsConfig: selectors.getMasterAccountDisplayStatsConfig(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/dashboard/main.js